import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Authorization } from "../../common/AuthorizationCpt";
import {
  onlyDigitsNumbers,
  WInputTextImageRight,
} from "../../common/components/TemplateContainer/InputTemplates";
import { HTTP_METHODS } from "../../utils/constants";
import { dateToRegularFormat, getHHMM } from "../../utils/dates";
import { networkBackendRequest } from "../../utils/networkUtils";
import { formatNumber } from "../../utils/numbers";
import Sidebar from "../Sidebar/Sidebar";
import StatusTag from "../StatusTag/StatusTag";
import {
  BoldText,
  Container,
  DivContentAlert,
  DivContentAlertContinue,
  DivContentBorder,
  DivContentImgTurn,
  DivContentRestriction,
  DivContentVct,
  DivContentWarningComment,
  DivErrorComments,
  DivFlexColumContentTurn,
  DivFlexJustifyAlignTurn,
  DivFlexJustifyTurn,
  DivLabelAlert,
  DivLabelAlertContinue,
  DivLabelRestriction,
  DivLabelTurn,
  DivLabelTurnStep,
  DivLabelWarningComment,
  DivNumVolante,
  DivRestrictions,
  InfoContainer,
  RowContainer,
  SectionTitle,
  StatusContainer,
  Text,
  VehicleContainer,
  VehicleRow,
  VolanteContainer,
} from "./TurnConfirmationSidebarStyles";

import icCheckValid from "../../images/ic_check_valid.svg";
import ImgStepOne from "../../images/img_step_one_valid.png";
import ImgStepTwo from "../../images/img_step_two_valid.png";
import ImgStepThree from "../../images/img_step_three_valid.png";
import ImgBlank from "../../images/ic_image_blank.png";
import ImgCheckSuccessGif from "../../images/animation-check-proority-black.gif";
import IconSecurityServices from "../../images/icon_carbon_security-services.svg";
import ImgProcessingTalma from "../../images/processing_talma.png";
import ImgContinueRestriction from "../../images/img_continue-restriction_step.png";
import LoadingGray from "../../images/loading_gray.gif";
import LoadingTalmaClick from "../../images/loader-talmaclick.gif";
import IconRightTurn from "../../images/ic_vector_right_turn.svg";
import icInfoRed from "../../images/ic_info_red.svg";
import icAlertTurn from "../../images/ic_alert_turn.svg";
import { ButtonGenericAll } from "../../common/components/PaymentStyles";
import { useAsyncExecutor2 } from "async-executor-hook";
import { from, map } from "rxjs";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  Validators,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import { parse, stringify } from "query-string";
import { useHistory } from "react-router-dom";
import { getErrorValueResponse } from "../../common/error/Error";
import TurnProcessingSidebar from "./TurnProcessingSidebar";
import {
  ExecutorgetServicePending,
  ExecutorgetValidNumTurn,
  ExecutorgetValidRestriction,
} from "./TurnConfirmation.interface";
import {
  AppointmentConvert,
  Vehicle,
  Volante,
} from "../AdminTurnConfirmation/turnConfirmation/AdminTurnConfirmation.interface";

interface Props {
  sidebarInfo: AppointmentConvert;
  onOutsideClick: () => void;
  onErrorEndpoint: (data: string) => void;
}
function TurnConfirmationSidebar(props: Props) {
  const { sidebarInfo, onOutsideClick, onErrorEndpoint } = props;
  const toast: any = useRef();
  const hideSidebar = () => {
    onOutsideClick();
  };

  let parcelsNum = 0;

  sidebarInfo.volantes.forEach((volante) => {
    parcelsNum += Number(volante.parcels_num);
  });

  const [stepValid, setStepValid] = useState<number>(1);

  const getValidRestriction = useAsyncExecutor2(
    (params: ExecutorgetValidRestriction) => {
      const { appointment_id } = params;
      return networkBackendRequest(
        `/volantes/appointment/${appointment_id}/restrictions/`,
        HTTP_METHODS.GET
      ).then((resp) => resp.json());
    },
    {
      onSuccess: () => {},
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        onOutsideClick();
        onErrorEndpoint(errorMessage);
      },
    }
  );

  const [showErrorVtcValidate, setShowErrorVtcValidate] = useState("");
  const getValidNumTurn = useAsyncExecutor2(
    (params: ExecutorgetValidNumTurn) => {
      return from(
        networkBackendRequest(
          `/appointments/vct-validation/`,
          HTTP_METHODS.GET,
          {
            appointment_id: params.appointment_id,
            vct: params.vct,
          },
          undefined
        ).then((resp) => resp.json())
      ).pipe(
        map((resp) => {
          return !resp.is_valid
            ? {
                codeConpensation: resp.is_valid,
                num_turn: resp.is_valid,
                error_comments: resp.error_comments,
              }
            : resp;
        })
      );
    },
    {
      onSuccess: (data) => {
        if (data.error_comments.length === 0) {
          setStepValid(3);
        }
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);

        setShowErrorVtcValidate(errorMessage);
      },
    }
  );

  const [showWarningComment, setShowWarningComment] = useState(false);

  const getServicePending = useAsyncExecutor2(
    (params: ExecutorgetServicePending) => {
      const { appointment_id } = params;
      return networkBackendRequest(
        `/appointments/${appointment_id}/pending-services/`,
        HTTP_METHODS.GET
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (data, params) => {
        if (data.warning_comments.length > 0) {
          setShowWarningComment(true);
        } else {
          patchConfirmationTurn.execute({
            appointment_id: data.appointment_id,
            vct_id: params.vtc_id,
          });
        }
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        onOutsideClick();
        onErrorEndpoint(errorMessage);
      },
    }
  );

  const patchConfirmationTurn = useAsyncExecutor2(
    (params: any) => {
      const { appointment_id, vct_id } = params;
      return networkBackendRequest(
        `/appointments/admin/${appointment_id}`,
        HTTP_METHODS.PATCH,
        { appointment_id },
        {
          vct_id,
        }
      ).then((resp) => resp.json());
    },
    {
      onSuccess: () => {
        setStepValid(4);
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        onOutsideClick();
        onErrorEndpoint(errorMessage);
      },
    }
  );

  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        vct: new FormControl(null, [
          Validators.required,
          Validators.pattern(/^[0-9]{14}$/),
        ]),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });

        return;
      }
      getValidNumTurn.execute({
        vct: form.value.vct,
        appointment_id: sidebarInfo.id,
      });
    },
  });

  const { loadSucceed } = formConfig;

  useEffect(() => {
    loadSucceed({ vct: "" });
  }, [loadSucceed]);

  const [showAlertBeforeContinue, setShowAlertBeforeContinue] = useState(false);
  const history = useHistory();
  return (
    <Sidebar onOutsideClick={hideSidebar}>
      <Container>
        <Toast ref={toast}></Toast>
        <Authorization actions={["appointment.update_appointment_admin"]}>
          {(stepValid === 1 || stepValid === 2 || stepValid === 3) &&
            !(
              getValidNumTurn.isSuccess &&
              getValidNumTurn.data.error_comments.length > 0 &&
              showAlertBeforeContinue
            ) && (
              <img
                src={
                  stepValid === 1
                    ? ImgStepOne
                    : stepValid === 2
                    ? ImgStepTwo
                    : getServicePending.isSuccess &&
                      stepValid === 3 &&
                      getServicePending.data.warning_comments.length > 0 &&
                      showWarningComment
                    ? ImgBlank
                    : ImgStepThree
                }
                alt=""
                style={{ height: "4.6rem", width: "22rem" }}
              />
            )}
          {(getServicePending.status === "PROCESSING" ||
            patchConfirmationTurn.status === "PROCESSING" ||
            getValidNumTurn.status === "PROCESSING") && (
            <TurnProcessingSidebar />
          )}
          {stepValid === 1 && (
            <DivFlexJustifyTurn>
              <div>
                <DivLabelTurnStep
                  fontWeight={700}
                  fontSize="2rem"
                  color="#08082B"
                  marginTop="1.9rem"
                >
                  Validación de restricciones
                </DivLabelTurnStep>
                <div style={{ marginTop: "2rem" }}>
                  <SectionTitle light={true}>AGENTE DE ADUANA</SectionTitle>
                  <DivLabelTurnStep fontWeight={700}>
                    {sidebarInfo.agentName}
                  </DivLabelTurnStep>
                </div>
                <div style={{ marginTop: "2rem" }}>
                  <SectionTitle light={true}>VOLANTES A VALIDAR</SectionTitle>
                  <DivLabelTurnStep>
                    {sidebarInfo.volantes
                      .map((volante: Volante) => volante.volante_num)
                      .join(", ")}
                  </DivLabelTurnStep>
                </div>
                <SectionTitle light={true}>RESTRICCIONES</SectionTitle>
                {getValidRestriction.isSuccess &&
                  getValidRestriction.data.restrictions.length > 0 && (
                    <>
                      <DivContentRestriction>
                        <img src={icInfoRed} alt="info-red" />
                        <DivLabelRestriction>
                          Hay {getValidRestriction.data.restrictions.length}{" "}
                          restricciones, para continuar con la confirmación de
                          turno hay que levantar las restricciones
                        </DivLabelRestriction>
                      </DivContentRestriction>
                      {getValidRestriction.data.restrictions.map((warning) => {
                        return (
                          <DivRestrictions key={warning.code}>
                            <div style={{ width: "17.1rem" }}>
                              <StatusTag
                                status={{
                                  label: `${warning.restriction_type.label}`,
                                  category: warning.restriction_type.category,
                                }}
                              />
                            </div>
                            <DivNumVolante>
                              Nº Volante{" "}
                              {warning.volante_nums
                                .map((e: string) => e)
                                .join(", ")}
                            </DivNumVolante>
                          </DivRestrictions>
                        );
                      })}
                    </>
                  )}
              </div>
              <DivContentBorder
                border={
                  getValidRestriction.status === "PROCESSING" ||
                  getValidRestriction?.data?.restrictions.length
                    ? "1px solid #FFFFFF"
                    : "1px solid #E7E7EA"
                }
              >
                <DivContentImgTurn>
                  {!(getValidRestriction.status === "PROCESSING") &&
                    stepValid === 1 &&
                    !getValidRestriction.isSuccess &&
                    !getValidRestriction.isError && (
                      <>
                        <img
                          src={IconSecurityServices}
                          alt="SecurityServices"
                        />
                        <div style={{ textAlign: "center", marginTop: "3rem" }}>
                          Realiza la validación de restricciones para continuar.
                        </div>
                      </>
                    )}
                  {getValidRestriction.status === "PROCESSING" && (
                    <>
                      <img src={ImgProcessingTalma} alt="" />
                      <img
                        src={LoadingTalmaClick}
                        alt="loading"
                        className="icon-loading"
                      />
                      <div>Estamos validando</div>
                      <DivLabelTurn>
                        Estamos validando si los volantes tienen restricciones
                      </DivLabelTurn>
                    </>
                  )}
                  {getValidRestriction.isSuccess &&
                    getValidRestriction.data.restrictions.length === 0 && (
                      <>
                        <img
                          src={ImgContinueRestriction}
                          alt="ContinueRestriction"
                        />
                        <div style={{ textAlign: "center", marginTop: "3rem" }}>
                          Volantes no tienen restricciones.
                        </div>
                      </>
                    )}
                </DivContentImgTurn>
              </DivContentBorder>
              <div>
                {(stepValid === 1 || stepValid === 2) &&
                  !(getValidRestriction.status === "PROCESSING") && (
                    <ButtonGenericAll
                      height="6.2rem"
                      marginBottom="2.5rem"
                      onClick={() => {
                        if (
                          (stepValid === 1 && !getValidRestriction.isSuccess) ||
                          (getValidRestriction.isSuccess &&
                            getValidRestriction.data.restrictions.length > 0)
                        ) {
                          getValidRestriction.execute({
                            appointment_id: sidebarInfo.id,
                          });
                        } else if (
                          stepValid === 1 &&
                          getValidRestriction.isSuccess &&
                          getValidRestriction.isSuccess &&
                          getValidRestriction.data.restrictions.length < 1
                        ) {
                          setStepValid(2);
                        } else {
                          setStepValid(3);
                        }
                      }}
                      borderColor="#88B13B"
                      backgroundColor="#88B13B"
                      color="#FFFFFF"
                    >
                      {stepValid === 1 &&
                        !getValidRestriction.isSuccess &&
                        !getValidRestriction.isError && (
                          <>
                            <img src={icCheckValid} alt="img-check-valid" />
                            <div style={{ marginLeft: "1.25rem" }}>
                              Validar restricciones
                            </div>
                          </>
                        )}
                      {getValidRestriction.isSuccess &&
                        getValidRestriction.data.restrictions.length > 0 && (
                          <>
                            <div style={{ marginRight: "1.25rem" }}>
                              Volver a validar restricciones
                            </div>
                            <img src={icCheckValid} alt="img-restriction" />
                          </>
                        )}
                      {getValidRestriction.isSuccess &&
                        getValidRestriction.data.restrictions.length < 1 && (
                          <>
                            <div style={{ marginRight: "1.25rem" }}>
                              Continuar
                            </div>
                            <img src={IconRightTurn} alt="img-right-turn" />
                          </>
                        )}
                    </ButtonGenericAll>
                  )}
              </div>
            </DivFlexJustifyTurn>
          )}
          {(stepValid === 2 || stepValid === 3) &&
            !(
              getValidNumTurn.status === "PROCESSING" ||
              getServicePending.status === "PROCESSING" ||
              patchConfirmationTurn.status === "PROCESSING"
            ) && (
              <>
                {getServicePending.isSuccess &&
                stepValid === 3 &&
                getServicePending.data.warning_comments.length > 0 &&
                showWarningComment ? (
                  <>
                    <DivFlexJustifyAlignTurn>
                      <DivContentAlert>
                        <img src={icAlertTurn} alt="" />
                        <DivLabelAlert>Alerta</DivLabelAlert>
                      </DivContentAlert>
                      <div>
                        {getServicePending.data.warning_comments.map(
                          (alertVol) => {
                            return (
                              <DivContentWarningComment key={alertVol}>
                                <DivLabelWarningComment>
                                  {alertVol}
                                </DivLabelWarningComment>
                              </DivContentWarningComment>
                            );
                          }
                        )}
                      </div>
                      <div>
                        <DivContentAlertContinue>
                          <DivLabelAlertContinue>
                            Es responsabilidad del usuario validador revisar lo
                            alertado antes de continuar. ¿Desea continuar?
                          </DivLabelAlertContinue>
                        </DivContentAlertContinue>
                        <div
                          style={{
                            marginTop: "4.2rem",
                            width: "100%",
                            display: "flex",
                          }}
                        >
                          <ButtonGenericAll
                            height="6.2rem"
                            marginBottom="2.5rem"
                            type="button"
                            borderColor="#88B13B"
                            backgroundColor="#FFFFFF"
                            color="#88B13B"
                            onClick={() => {
                              setShowWarningComment(false);
                            }}
                            disabled={patchConfirmationTurn.isLoading}
                          >
                            <div>Cancelar</div>
                          </ButtonGenericAll>
                          <ButtonGenericAll
                            height="6.2rem"
                            marginBottom="2.5rem"
                            marginLeft="1rem"
                            type="button"
                            borderColor="#88B13B"
                            backgroundColor="#88B13B"
                            color="#FFFFFF"
                            onClick={() => {
                              patchConfirmationTurn.execute({
                                appointment_id: sidebarInfo.id,
                                vct_id:
                                  getValidNumTurn.isSuccess &&
                                  getValidNumTurn.data.vct,
                              });
                            }}
                            disabled={patchConfirmationTurn.isLoading}
                          >
                            <div style={{ marginRight: "1.25rem" }}>
                              Confirmar
                            </div>
                            {patchConfirmationTurn.isLoading ||
                            getServicePending.isLoading ? (
                              <img src={LoadingGray} alt="icon-loading-gray" />
                            ) : (
                              <img src={icCheckValid} alt="ConfirmButton" />
                            )}
                          </ButtonGenericAll>
                        </div>
                      </div>
                    </DivFlexJustifyAlignTurn>
                  </>
                ) : (
                  <>
                    <div className="header">
                      <div>
                        <DivLabelTurnStep
                          fontWeight={700}
                          fontSize="2rem"
                          color="#08082B"
                          marginTop="1.9rem"
                        >
                          Validación de turno
                        </DivLabelTurnStep>
                        <div style={{ marginTop: "2rem" }}>
                          <SectionTitle light={true}>
                            AGENTE DE ADUANA
                          </SectionTitle>
                          <DivLabelTurnStep fontWeight={700}>
                            {sidebarInfo.agentName && sidebarInfo.agentName}
                          </DivLabelTurnStep>
                        </div>
                        <div style={{ marginTop: "2rem" }}>
                          <SectionTitle light={true}>
                            VOLANTES A VALIDAR
                          </SectionTitle>
                          <DivLabelTurnStep>
                            {sidebarInfo.volantes
                              .map((volante) => volante.volante_num)
                              .join(", ")}
                          </DivLabelTurnStep>
                        </div>
                        <div style={{ marginTop: "2rem" }}>
                          <SectionTitle light={true}>
                            RESTRICCIONES
                          </SectionTitle>
                          <StatusContainer>
                            <StatusTag
                              status={{
                                label: `${
                                  getValidRestriction?.data.restrictions
                                    .length < 1
                                    ? "SIN RESTRICCIONES"
                                    : `CON ${
                                        getValidRestriction?.data.restrictions
                                          .length
                                      } ${
                                        getValidRestriction?.data.restrictions
                                          .length === 1
                                          ? "RESTRICCION"
                                          : "RESTRICCIONES"
                                      }`
                                }`,
                                category: `${
                                  getValidRestriction?.data.restrictions
                                    .length < 1
                                    ? "ok"
                                    : "problem"
                                }`,
                              }}
                            />
                          </StatusContainer>
                        </div>
                      </div>
                    </div>
                    <WForm
                      formConfig={formConfig}
                      style={{ width: "100%" }}
                      globalErrorMessages={{
                        minlength: (val) => {
                          return `El valor tiene ${val.actualLength}. Valor mínimo requerido ${val.requiredLength}`;
                        },
                        maxlength: (val) => {
                          return `Máximo Valor ${val.requiredLength}`;
                        },
                      }}
                    >
                      <InfoContainer>
                        <div>
                          <div style={{}}>
                            {getValidNumTurn.isSuccess &&
                            getValidNumTurn.data &&
                            stepValid === 3 ? (
                              <>
                                <div style={{ marginTop: "2rem" }}>
                                  <SectionTitle light={true}>
                                    NÚMERO DE TURNO
                                  </SectionTitle>
                                  <DivContentVct>
                                    <div>{getValidNumTurn.data.vct}</div>
                                  </DivContentVct>
                                </div>
                              </>
                            ) : (
                              <>
                                <WFormControl
                                  name="vct"
                                  errorMessages={{
                                    required: "Campo requerido",
                                    maxlength: "Máximo 14 caracteres",
                                    pattern:
                                      "Ingrese solo números y 14 dígitos, evitar los espacios",
                                  }}
                                >
                                  <TemplateInputContainer
                                    label="NÚMERO DE TURNO"
                                    color="#08082B"
                                  >
                                    <WInputTextImageRight
                                      haveErros={
                                        getValidNumTurn.isSuccess &&
                                        getValidNumTurn.data.error_comments
                                          .length > 0
                                      }
                                      isErrorEndpoint={getValidNumTurn.isError}
                                      isSucessEndpoint={
                                        getValidNumTurn.isSuccess
                                      }
                                      width="100%"
                                      height="5rem"
                                      placeholder="Ingrese número de VCT"
                                      onKeyPress={onlyDigitsNumbers}
                                      maxLength={14}
                                    />
                                  </TemplateInputContainer>
                                </WFormControl>
                                {getValidNumTurn.isSuccess && (
                                  <div>
                                    {getValidNumTurn.data.error_comments.map(
                                      (errorComment) => {
                                        return (
                                          <DivErrorComments key={errorComment}>
                                            {errorComment}
                                          </DivErrorComments>
                                        );
                                      }
                                    )}
                                  </div>
                                )}
                                {getValidNumTurn.isError && (
                                  <DivErrorComments>
                                    {showErrorVtcValidate}
                                  </DivErrorComments>
                                )}
                              </>
                            )}
                            <div className="dispatcher-container">
                              <SectionTitle light={true}>DNI</SectionTitle>
                              <Text>
                                {sidebarInfo.dispatcherDocumentNumber &&
                                  sidebarInfo.dispatcherDocumentNumber}{" "}
                              </Text>
                            </div>
                            <div className="dispatcher-container">
                              <SectionTitle light={true}>
                                {" "}
                                DESPACHADOR
                              </SectionTitle>
                              <Text>
                                {sidebarInfo.dispatcher &&
                                  sidebarInfo.dispatcher}{" "}
                              </Text>
                            </div>
                            <RowContainer>
                              <div>
                                <SectionTitle light={true}>GRUPOS</SectionTitle>
                                <Text>
                                  {sidebarInfo.groups && sidebarInfo.groups}
                                </Text>
                              </div>
                              <div>
                                <SectionTitle light={true}>PESO</SectionTitle>
                                <Text>{`${formatNumber(
                                  sidebarInfo.weight && sidebarInfo.weight
                                )} kg`}</Text>
                              </div>
                            </RowContainer>
                            <RowContainer>
                              <div>
                                <SectionTitle light={true}>BULTOS</SectionTitle>
                                <Text>{parcelsNum}</Text>
                              </div>
                              <div>
                                <SectionTitle light={true}>
                                  SEGMENTO
                                </SectionTitle>
                                <Text>{sidebarInfo?.segmentCategory}</Text>
                              </div>
                            </RowContainer>
                            <RowContainer>
                              <div>
                                <SectionTitle light={true}>
                                  HORA DE RETIRO
                                </SectionTitle>
                                <Text>{`${getHHMM(
                                  sidebarInfo.timeslotStart
                                )} A ${getHHMM(
                                  sidebarInfo.timeslotEnd
                                )}`}</Text>
                              </div>
                              <div>
                                <SectionTitle light={true}>FECHA</SectionTitle>
                                <Text>
                                  {dateToRegularFormat(
                                    sidebarInfo.withdrawalDate
                                  )}
                                </Text>
                              </div>
                            </RowContainer>
                            <RowContainer>
                              <div>
                                <SectionTitle light={true}>
                                  NÚMERO DE TURNO
                                </SectionTitle>
                                <Text>
                                  {sidebarInfo.turnNum
                                    ? sidebarInfo.turnNum
                                    : "-"}
                                </Text>
                              </div>
                              <div>
                                <SectionTitle light={true}>
                                  COD. DIQUE
                                </SectionTitle>
                                <Text>
                                  {sidebarInfo.dockNum
                                    ? sidebarInfo.dockNum
                                    : "-"}
                                </Text>
                              </div>
                            </RowContainer>
                            <div>
                              <SectionTitle>{`Volantes (${sidebarInfo.volantes.length})`}</SectionTitle>
                              {sidebarInfo.volantes.map((volante: Volante) => (
                                <VolanteContainer key={volante.volante_num}>
                                  <div>
                                    <BoldText small={true}>
                                      {volante.volante_num}
                                    </BoldText>
                                  </div>
                                  <div>
                                    <SectionTitle light={true} small={true}>
                                      GUÍA MADRE
                                    </SectionTitle>
                                    <Text small={true}>
                                      {volante.master_air_waybill}
                                    </Text>
                                  </div>
                                  <div>
                                    <SectionTitle light={true} small={true}>
                                      GUÍA HIJA
                                    </SectionTitle>
                                    <Text small={true}>
                                      {volante.house_air_waybill}
                                    </Text>
                                  </div>
                                </VolanteContainer>
                              ))}
                            </div>
                            <div>
                              <SectionTitle>{`Vehículos (${sidebarInfo.vehicles.length})`}</SectionTitle>
                              {sidebarInfo.vehicles.map((vehicle: Vehicle) => (
                                <VehicleContainer key={vehicle.plate}>
                                  <VehicleRow>
                                    <div>
                                      <SectionTitle light={true} small={true}>
                                        TIPO DE VEHÍCULO
                                      </SectionTitle>
                                      <Text small={true}>
                                        {vehicle.vehicle_category.label}
                                      </Text>
                                    </div>
                                    <div>
                                      <SectionTitle light={true} small={true}>
                                        PLACA
                                      </SectionTitle>
                                      <Text small={true}>{vehicle.plate}</Text>
                                    </div>
                                  </VehicleRow>
                                  <VehicleRow>
                                    <div>
                                      <SectionTitle light={true} small={true}>
                                        DNI
                                      </SectionTitle>
                                      <Text small={true}>
                                        {vehicle.driver.document_number}
                                      </Text>
                                    </div>
                                    <div>
                                      <SectionTitle light={true} small={true}>
                                        BREVETE
                                      </SectionTitle>
                                      <Text small={true}>
                                        {vehicle.driver.brevete}
                                      </Text>
                                    </div>
                                  </VehicleRow>
                                  <>
                                    <div>
                                      <SectionTitle light={true} small={true}>
                                        TRANSPORTISTA
                                      </SectionTitle>
                                      <Text small={true}>
                                        {vehicle.driver.name}
                                      </Text>
                                    </div>
                                  </>
                                </VehicleContainer>
                              ))}
                            </div>
                          </div>
                        </div>
                      </InfoContainer>
                      {stepValid === 3 ? (
                        <div style={{ marginTop: "4.2rem", width: "100%" }}>
                          <ButtonGenericAll
                            height="6.2rem"
                            marginBottom="2.5rem"
                            type="button"
                            borderColor="#88B13B"
                            backgroundColor="#88B13B"
                            color="#FFFFFF"
                            onClick={() => {
                              if (
                                getValidNumTurn.isSuccess &&
                                stepValid === 3 &&
                                getValidNumTurn.data.error_comments.length > 0
                              ) {
                                setShowAlertBeforeContinue(true);
                              } else {
                                getServicePending.execute({
                                  appointment_id: sidebarInfo.id,
                                  vtc_id:
                                    getValidNumTurn.isSuccess &&
                                    getValidNumTurn.data.vct,
                                });
                              }
                            }}
                          >
                            <img src={icCheckValid} alt="ConfirmStep3" />
                            <div style={{ marginLeft: "1.25rem" }}>
                              Confirmar
                            </div>
                          </ButtonGenericAll>
                        </div>
                      ) : (
                        <div style={{ marginTop: "4.2rem", width: "100%" }}>
                          <ButtonGenericAll
                            height="6.2rem"
                            marginBottom="2.5rem"
                            type="submit"
                            borderColor="#88B13B"
                            backgroundColor="#88B13B"
                            color="#FFFFFF"
                            disabled={
                              formConfig?.form?.value.vct.length !== 14 ||
                              getValidNumTurn.isLoading ||
                              formConfig?.form?.invalid
                            }
                          >
                            <img src={icCheckValid} alt="img-check-valid" />
                            <div style={{ marginLeft: "1.25rem" }}>
                              Validar Nº de turno
                            </div>
                          </ButtonGenericAll>
                        </div>
                      )}
                    </WForm>
                  </>
                )}
              </>
            )}
          {stepValid === 4 && (
            <>
              <DivFlexColumContentTurn>
                <DivContentImgTurn>
                  <img
                    src={ImgCheckSuccessGif}
                    alt=""
                    className="icon-check-success"
                  />
                  <div style={{ marginTop: "6.3rem" }}>Turno confirmado</div>
                  <DivLabelTurn>
                    Se ha confirmado el turno exitosamente.
                  </DivLabelTurn>
                </DivContentImgTurn>
              </DivFlexColumContentTurn>
              <div style={{ marginTop: "4.2rem", width: "100%" }}>
                <ButtonGenericAll
                  height="6.2rem"
                  marginBottom="2.5rem"
                  type="button"
                  borderColor="#88B13B"
                  backgroundColor="#88B13B"
                  color="#FFFFFF"
                  onClick={() => {
                    onOutsideClick();
                    const parsedParams = {
                      ...parse(window.location.search),
                      page: 1,
                    };
                    const stringifiedParams = stringify(parsedParams);
                    const pathname = history.location.pathname;
                    history.push(`${pathname}?${stringifiedParams}`);
                  }}
                >
                  <div>Entendido</div>
                </ButtonGenericAll>
              </div>
            </>
          )}
        </Authorization>
      </Container>
    </Sidebar>
  );
}

export default TurnConfirmationSidebar;
